import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { SiteFooter } from "@/components/legal/SiteFooter";

export const Section = ({ id, title, children }) => (
  <section id={id} className="scroll-mt-24">
    <h2 className="mb-3 mt-10 font-display text-xl font-bold text-white sm:text-2xl">{title}</h2>
    <div className="space-y-3 text-sm leading-relaxed text-[#c9c5dd] [&_li]:ml-5 [&_li]:list-disc [&_strong]:text-white">{children}</div>
  </section>
);

export const LegalLayout = ({ title, updated, testId, children }) => {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) document.querySelector(hash)?.scrollIntoView();
    else window.scrollTo(0, 0);
  }, [hash]);
  return (
    <div className="grain min-h-screen">
      <header className="relative z-10 border-b border-white/10 px-4 py-4 md:px-8"><Logo size="text-xl" /></header>
      <main className="relative z-10 mx-auto max-w-3xl px-5 py-12" data-testid={testId}>
        <h1 className="font-display text-4xl font-black tracking-tight sm:text-5xl">{title}</h1>
        <p className="mt-3 text-xs uppercase tracking-widest text-muted-foreground">Hatályos: {updated}</p>
        {children}
        <SiteFooter />
      </main>
    </div>
  );
};
